<template>
    <div class="stayOutForDaysRecord ">
        <!-- :model="formInline" -->
        <div class="form-content">
            <el-form :inline="true" class="demo-form-inline" :model="formData">
                <template v-if="role !== 'headmaster'">
                    <el-form-item label="部门:">
                        <el-input v-model="formData.deptValue" readonly placeholder="请选择部门" style="cursor:pointer;width: 170px" @click.native="deptValueShow = !deptValueShow" suffix-icon="el-icon-arrow-down"></el-input>
                        <el-tree  ref="tree" node-key="id" v-show="deptValueShow" :data="deptData" :props="deptProps" :expand-on-click-node="false" @node-click="deptTreeNodeHandleClick" style="width:170px" class="combotree">
                        </el-tree>
                    </el-form-item>
                    <el-form-item label="楼栋:">
                        <template v-if="role === 'admin' || role == 'logisticsadmin'">
                            <el-input v-model="formData.houseValue" readonly placeholder="请选择楼栋" style="cursor:pointer;width: 150px" suffix-icon="el-icon-arrow-down" class="wcyc-combotree" @click.native="buildingUnitSelectShow = !buildingUnitSelectShow"></el-input>
                            <el-tree v-show="buildingUnitSelectShow" :props="buildingProps" :data="buildingData" :expand-on-click-node="false" @node-click="builidingTreeNodeHandleClick" style="width:170px" class="combotree wcyc-combotree-panel">
                            </el-tree>
                        </template>
                        <el-select v-if="role === 'housekeeper'" v-model="formData.houseId" placeholder="请选择楼栋" style="width:150px;height:30px;" :disabled="HouseByManagerUserCombobox.length < 2" @change="builidingTreeComboHandleClick">
                            <el-option v-for="item in HouseByManagerUserCombobox" :key="item.houseId" :label="item.houseName" :value="item.houseId">
                            </el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item label="楼层:">
                        <el-select v-model="formData.floorId" placeholder="请先选择楼层" style="width:90px" clearable :disabled="!currentBuildingNode || currentBuildingNode.leavel !== 2">
                            <el-option :key="''" label="全部" :value="''">
                            </el-option>
                            <el-option v-for="item in floorList" :key="item.floorId" :label="item.floorName" :value="item.floorId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="宿舍名:">
                        <el-input v-model="formData.dormitoryName" placeholder="请输入宿舍名" style="width: 110px"></el-input>
                    </el-form-item>
                </template>

                <el-form-item v-else label="班级:">
                    <el-select v-model="formData.classId" placeholder="请选择班级" style="width:150px;" :disabled="classAreaList.length < 2">
                        <el-option v-for="item in classAreaList" :key="item.id" :label="item.className" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="姓名:">
                    <el-input v-model="formData.studentName" placeholder="请输入姓名" style="width: 110px"></el-input>
                </el-form-item>
                <el-form-item label="学号:">
                    <el-input v-model="formData.studentCode" placeholder="请输入学号" style="width: 110px"></el-input>
                </el-form-item>

                <el-form-item label="考勤日期:">
                    <el-date-picker ref="startTime" :clearable="false" v-model="formData.startTime" type="date" value-format="yyyy-MM-dd" style="width: 150px" @change="startDateChange">
                    </el-date-picker>&emsp;至
                </el-form-item>
                <el-form-item label="" label-width="0px">
                    <el-date-picker ref="endTime" :clearable="false" v-model="formData.endTime" type="date" value-format="yyyy-MM-dd" style="width: 150px" :picker-options="endtimepickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="考勤类型:">
					<el-select style="width:120px" v-model="formData.suguanAttenType" size="small">
						<el-option
							v-for="item in attendceType"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
                <div style="float: right;margin-right: 20px;height:40px;">
                    <el-button class="query" @click="query">查询</el-button>
                    <el-button class="reset" @click="reset">重置</el-button>
                    <el-button type="primary" @click="exportExl">导出记录</el-button>
                </div>

            </el-form>
        </div>
        <div class="tableList">
            <template>
                <el-table border stripe :data="dataList" header-row-class-name="table-header" style="width: 1200px;" @sort-change="tableSortChange">

                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="studentCode" label="学号" align="center">
                    </el-table-column>
                    <el-table-column prop="studentName" label="姓名" align="center">
                        <span class="studentname" slot-scope="scope" @click="studentInfoDialog(scope.row.studentId, $event)">{{scope.row.studentName}}</span>
                    </el-table-column>
                    <el-table-column prop="sex" label="性别" align="center">
                    </el-table-column>
                    <el-table-column prop="className" label="班级" align="center">
                    </el-table-column>
                    <el-table-column prop="houseName" label="楼栋" align="center">
                    </el-table-column>
                    <el-table-column prop="dormitoryName" label="宿舍名" align="center">
                    </el-table-column>
                    <el-table-column prop="currentTotal" label="未归天数" align="center" sortable='custom'>
                    </el-table-column>
                    <el-table-column prop="inOutTime" label="最近刷脸时间" align="center" sortable='custom'>
                    </el-table-column>
                    <el-table-column prop="picUrl" label="照片" align="center">
                        <template slot-scope="scope">
                            <span class="pic" @click="openPicDialog(scope.row)"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div class="pagination-container ">
                <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination"></v-pagination>
            </div>
        </div>

        <el-dialog title="抓拍照片对比" :visible.sync="dialogPic" width="700px">
            <div style="padding:0 89px;overflow:hidden;">
                <div style="width: 222px; margin-right:38px;height: 360px;float: left;text-align:center;">
                    <span>{{currentPicInfo.uploadTime}}</span>
                    <!--<img v-bind:src="currentPicInfo.image"/>-->
                    <div class="img" style="width:223px;height: 303px;border: solid 1px  #cccccc;text-align:center;margin:10px 0;">
                        <img v-show="currentPicInfo.image" :src="currentPicInfo.image" style="width: 220px;height: 300px">
                    </div>
                    <span style="font-weight:bold">人员照片</span>
                </div>
                <div style="width: 222px;height: 360px;float: left;text-align:center;">
                    <span>{{currentPicInfo.inOutTime}}</span>
                    <div class="img" style="width:222px;height: 303px;border: solid 1px  #cccccc;margin:10px 0;">
                        <img v-show="currentPicInfo.inOutImage" :src="currentPicInfo.inOutImage" style="width: 220px;height: 300px">
                    </div>
                    <!--<img v-bind:src="currentPicInfo.inOutImage"/>-->
                    <span style="font-weight:bold">抓拍照片</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { session } from '@/util'
import basetable from '@/mixins/base-table';
import studentInfo from '@/components/studentInfo/studentInfo.vue'
import api from '@/api'
import {attendceType} from '@/pages/systemConfig/attendanceRuleConfig.vue'

export default {
    components: {
        vStudentInfo: studentInfo
    },
    mixins: [basetable],

    props: {
        classAreaList: {
            type: Array,
            default: []
        }
    },
    data () {
        let user = session('user');
        let vm = this;
        return {
            user,
            doNotInit: true,
            role: user.tsr.roleCode,
            currentStudentInfo: {},
            studentDomTarget: null,
            attendceType,
            // showStudentInfoDialog: false,
            formData: {
                schoolId: '',
                schoolNum: '',//校区Id
                departmentId: '',//院系ID
                gradeId: '',// 年级Id
                classId: this.classAreaList.length > 0 ? this.classAreaList[0].id : '', // 班级Id
                deptName: "", // 部门名称
                deptValue: "",//部门
                houseId: "", // 楼栋id
                houseName: "", // 楼栋名称
                houseValue: '',//楼栋
                dormitoryName: "", // 宿舍号
                studentName: "", // 学生姓名
                studentCode: "", // 学号
                startTime: "", // 开始时间
                endTime: "", // 结束时间
                floorId: "", // 楼层
                status: "", //考勤状态码,
                suguanAttenType: 1
            },
            doNotInit: true,
            dialogPic: false,
            currentPicInfo: {
                inOutImage: '',
                image: '',
                inOutTime: '',
                uploadTime: ''
            },
            deptValueShow: false,
            buildingUnitSelectShow: false,
            buildingProps: {
                label: 'lable',
                children: 'children',
                isLeaf: 'leaf'
            },
            // 部门数据
            deptProps: {
                label: 'directorName',
                children: 'nextLevels',
                isLeaf: 'leaf'
            },
            floorList: null,
            deptData: null,
            buildingData: null,
            HouseByManagerUserCombobox: [], // 宿管员楼栋下拉
            // statusList: null
            currentBuildingNode: null,
            // starttimepickerOptions: {
            //     disabledDate (time) {
            //         if (vm.formData.endTime) {
            //             return time > new Date(vm.formData.endTime).getTime();
            //         }
            //         return false;
            //     },
            // },
            endtimepickerOptions: {
                disabledDate (time) {
                    if (vm.formData.startTime) {
                        return time < new Date(vm.formData.startTime + ' 00:00:00').getTime();
                    }
                    return false;
                },
            }
        };
    },
    watch: {
        classAreaList(classAreaList) {
             this.formData.classId = classAreaList.length > 0 ?classAreaList[0].id : '';
        }
    },
    computed: {

    },
    methods: {
        startDateChange (v) {
            this.formData.endTime = v;
        },
        query () {
            this.page = 1;
            this.loadData();
        },
        queryHouseByManagerUser () {
            return api.summary.queryHouseByManagerUser().then(res => {
                if (res.code == 0) {
                    this.HouseByManagerUserCombobox = res.data;
                } else {
                    this.$layer.msg(res.message);
                }
            });
        },
        builidingTreeComboHandleClick (v) {
            this.formData.houseValue = v;
            this.formData.floorId = '';
            this.getFloorListByHouseId(this.formData.houseId);
        },
        tableSortChange (columnObj) {
            if (columnObj.order) {
                var order = columnObj.order === 'descending' ? columnObj.order.substring(0, 4) : columnObj.order.substring(0, 3);
                this.$set(this.formData, 'order', `${columnObj.prop},${order}`);
            }
            this.loadData();
        },
        // 加载表格数据
        loadData () {

            if (this.formData.startTime === null || this.formData.startTime === '') {
                this.showTip("请选择考勤开始时间查询", "error");
                return;
            }

            if (this.formData.endTime === null || this.formData.endTime === '') {
                this.showTip("请选择考勤结束时间查询", "error");
                return;
            }


            let str = 'schoolId=' + this.user.schoolId + '&status=4&';
            if (this.formData.schoolNum !== null && this.formData.schoolNum !== '') {
                str += '&schoolNum=' + this.formData.schoolNum;
            } if (this.formData.departmentId != null && this.formData.departmentId != '') {
                str += '&departmentId=' + this.formData.departmentId;
            } if (this.formData.gradeId != null && this.formData.gradeId != '') {
                str += '&gradeId=' + this.formData.gradeId;
            } if (this.formData.classId != null && this.formData.classId != '') {
                str += '&classId=' + this.formData.classId;
            } if (this.formData.houseId != null && this.formData.houseId != '') {
                str += '&houseId=' + this.formData.houseId;
            } if (this.formData.dormitoryName != null && this.formData.dormitoryName != '') {
                str += '&dormitoryName=' + this.formData.dormitoryName;
            } if (this.formData.studentName != null && this.formData.studentName != '') {
                str += '&studentName=' + this.formData.studentName;
            } if (this.formData.studentCode != null && this.formData.studentCode != '') {
                str += '&studentCode=' + this.formData.studentCode;
            } if (this.formData.startTime != null && this.formData.startTime != '') {
                str += '&startTime=' + this.formData.startTime;
            }
            if (this.formData.endTime != null && this.formData.endTime != '') {
                str += '&endTime=' + this.formData.endTime;
            }
            if (this.formData.floorId != null && this.formData.floorId != '') {
                str += '&floorId=' + this.formData.floorId;
            } if (this.formData.order != null && this.formData.order != '') {
                str += '&order=' + this.formData.order;
            } if (this.formData.classId != null && this.formData.classId != '') {
                str += '&classId=' + this.formData.classId;
            }
            if (this.formData.suguanAttenType != null && this.formData.clsuguanAttenTypessId != '') {
                str += '&suguanAttenType=' + this.formData.suguanAttenType;
            }
            api.attendanceQuery.findContinuityCheckList(str, this.page, this.size).then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.total;
                    this.dataList = data.list;
                } else {
                    this.$message(res.message);
                }
            })
        },


        // 点击查看学生资料
        studentInfoDialog (studentId, event) {
            api.attendanceQuery.getcurrentStudentInfo('userId=' + studentId)
                .then((res) => {
                    if (res.code == 0) {
                        let image = res.data.image;
                        if (image) {
                            image = image ? '/suguan/oss/d/' + image + '?token=' + session('token').accesstoken : '';
                        }
                        this.currentStudentInfo = {
                            name: res.data.student_name,
                            studentCode: res.data.student_code,
                            gender: res.data.sex,
                            bornDate: res.data.birthdate,
                            nation: res.data.nation,
                            cName: res.data.class_Name,
                            phoneNum: res.data.phone_num,
                            inDate: res.data.in_time,
                            image: image
                        }
                        this.studentDomTarget = event.target;
                        this.$emit('getcurrentStudentInfo', this.currentStudentInfo, this.studentDomTarget);
                    }
                })
        },
        // 点击放大图片
        // openPicDialog(data) {
        //   this.currentStudentRow = data;
        //   this.$emit('getcurrentCapturePciInfo', data);
        // },

        openPicDialog (row) {
            let studentId = row.studentId;
            let checkInId = row.id;
            let str = "studentId=" + studentId + "&&checkInId=" + checkInId;

            api.attendanceQuery.findStudentImage(str).then((res) => {
                if (res.code == 0) {
                    let inOutImage = res.data.inOutImage;
                    let image = res.data.image;
                    this.currentPicInfo.inOutImage = inOutImage ? '/suguan/oss/d/' + inOutImage + '?token=' + session('token').accesstoken : '';
                    this.currentPicInfo.image = image ? '/suguan/oss/d/' + image + '?token=' + session('token').accesstoken : '';
                    this.currentPicInfo.uploadTime = res.data.uploadTime;
                    this.currentPicInfo.inOutTime = res.data.inOutTime;
                }
                this.dialogPic = true;
            });

        },

        // 部门学校树枝
        deptTreeNodeHandleClick (data, node) {
            this.formData.schoolId = data.type == null || data.type == 1 ? data.schoolId : '';
            this.formData.departmentId = data.type == 2 || data.type == 3 ? data.relId : '';
            this.formData.classId = data.type == 5 ? data.relId : '';
            this.formData.schoolNum = data.type == 6 ? data.relId : '';
            if(data.type == 4) {
                this.formData.gradeId = data.relId;
                if(this.$refs.tree.getNode(data.parentId).data.type == 6) {
                    this.formData.schoolNum =this.$refs.tree.getNode(data.parentId).data.relId;
                }
            }
            this.deptValueShow = false;
            this.formData.deptValue = data.directorName;
        },
        // 楼栋树枝
        builidingTreeNodeHandleClick (data, node) {
            this.currentBuildingNode = data;
            // 选中楼栋
            if (data.leavel == 2) {
                this.formData.houseId = data.id;
                this.formData.houseValue = data.lable;
                this.formData.schoolNum = "";
                this.formData.floorId = '';
                api.attendanceQuery.getFloorListByHouseId(data.id)
                    .then((res) => {
                        if (res.code == 0) {
                            this.floorList = res.data;
                        }
                    })
            }//选中校区
            if (data.leavel == 1) {
                this.formData.houseId = "";
                this.formData.floorId = '';
                this.formData.schoolNum = data.schoolNum;
                this.formData.houseValue = data.lable;
            }//选中学校
            if (data.leavel == 0) {
                this.formData.houseId = "";
                this.formData.schoolNum = "";
                this.formData.floorId = '';
                this.formData.schoolId = data.id;
                this.formData.houseValue = data.lable;
            }
            // 关闭选择器
            this.buildingUnitSelectShow = false;
        },
        // 重置
        reset () {
            this.formData = {
                schoolId: this.user.schoolId,
                schoolNum: '',//校区Id
                departmentId: '',//院系ID
                gradeId: '',// 年级Id
                classId: '', // 班级Id
                deptName: "", // 部门
                deptValue: "",
                houseId: "", // 楼栋id
                houseName: '', //楼栋name
                houseValue: '',//楼栋
                dormitoryName: "", // 宿舍名
                studentName: "", // 学生姓名
                studentCode: "", // 学号
                startTime: "", // 开始时间
                endTime: "", // 结束时间
                floorId: "", // 楼层
                status: '4', //考勤状态码,
                suguanAttenType: 1
            }
        },
        // 导出
        exportExl () {
            if (this.formData.startTime === null || this.formData.startTime === '') {
                this.showTip("请选择未归开始时间查询", "error");
                return;
            }

            if (this.formData.endTime === null || this.formData.endTime === '') {
                this.showTip("请选择未归结束时间查询", "error");
                return;
            }
            api.systemConfig.exportContinuityCheckList(this.formData, 0, 9999999).then((res) => {
                if (res.code === 0) {
                    var key, value;
                    [key, value] = Object.entries(res.data)[0];
                    this.$common.globalExportExl(key, value, '多日未归统计记录');
                }
            });
        },
        // 返回当天年月日
        _setCurrentTime () {
            let date = new Date();
            let year = date.getFullYear();
            let month = this._padZero(date.getMonth() + 1);
            let day = this._padZero(date.getDate());
            return [year, month, day].join("-");
        },
        _padZero (str) {
            let start = str.length == 2 ? 0 : 1;
            return ("0" + str).substring(start);
        },
        tableHeaderClassName () {
            return 'table-header'
        },
        getFloorListByHouseId (houseId) {
            api.attendanceQuery.getFloorListByHouseId(houseId)
                .then((res) => {
                    if (res.code == 0) {
                        this.floorList = res.data;
                    }
                })
        },
    },
    created () {
        this.formData.schoolId = this.user.schoolId;
        this.formData.status = "4";
        api.common.querySchoolHouseTree(this.user.schoolId)
            .then((res) => {
                if (res.code == 0) {
                    this.buildingData = res.data.treeDTOList;
                } else {
                    this.$message(res.message);
                }
            })

        api.common.querySchoolRelationTree(this.user.schoolId)
            .then((res) => {
                if (res.code == 0) {
                    this.deptData = res.data;
                } else {
                    this.$message(res.message);
                }
            })

        if (this.role === "housekeeper") {
            this.queryHouseByManagerUser()
                .then(() => {
                    this.formData.houseId = this.HouseByManagerUserCombobox[0].houseId;
                    this.formData.houseValue = this.HouseByManagerUserCombobox[0].houseName;
                    this.getFloorListByHouseId(this.formData.houseId);

                });
        }

    },
    mounted () {

    }
};
</script>
<style type="text/css" lang="scss" rel="stylesheet/scss">
.stayOutForDaysRecord {
  padding-top: 20px;
  .el-form-item {
    height: 30px;
    margin-bottom: 10px;
    margin-right: 20px;
    font-size: 12x;
    .el-form-item__label {
      color: #666;
    }
    .el-input {
      width: auto;
    }
    .el-input__inner {
      padding: 0px 10px;
    }
    .el-date-editor--date {
      .el-input__inner {
        padding: 0px 10px 0 30px;
      }
    }
    .combotree {
      position: absolute;
      left: 0;
      top: 36px;
      z-index: 19920104;
      overflow: auto;
      height: 300px;
      min-width: 170px;
    }
  }
  .export {
    width: 90px;
    height: 30px;
    padding: 0;
    line-height: 30px;
    background-color: #26aef3;
    color: #fff;
    vertical-align: middle;
    a {
      display: inline-block;
      width: 100%;
      height: 100%;
      color: #fff;
    }
  }
  .query {
    width: 60px;
    height: 30px;
    padding: 0;
    line-height: 30px;
    background-color: #26aef3;
    color: #fff;
    vertical-align: middle;
  }
  .reset {
    width: 60px;
    height: 30px;
    padding: 0;
    line-height: 30px;
    background-color: #f7f7f7;
    vertical-align: middle;
  }
  .tableList {
    .studentname {
      color: #26aef3;
      cursor: pointer;
    }
  }
  .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border: none;
  }

  .el-table {
    color: #333;
    .normal {
      color: #000;
    }
    .stayout {
      color: red;
    }
    .late {
      color: #fbaf42;
    }
  }
  .el-table--border {
    border-radius: 5px;
  }
  .el-table td,
  .el-table th {
    height: 40px;
    padding: 0;
  }
  .table-header > th {
    height: 40px;
    padding: 0;
    background-color: #26aef3;
    color: #ffffff;
    font-weight: normal;
  }
  .pic {
    display: inline-block;
    width: 26px;
    height: 26px;
    background-image: url('avatar.png');
    cursor: pointer;
  }
}
.capture-compare-wrapper {
  padding: 10px 20px;
  ul {
    font-size: 0;
    & > li {
      width: 50%;
      display: inline-block;
      p {
        margin: 0;
        text-align: center;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/attendanceStatistics/stayOutForDaysRecord.vue